import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import './App.css';
import About from './pages/About';
import Contact from './pages/Contact';
import Home from './pages/Home';
import Collab from './pages/Collab';
import CollabCCAmstel from './pages/CollabCCAmstel';
import ScrollToTop from './components/Scroll-top'; // Import the component
import Footer from './components/Footer';
import ProductOffering from './pages/ProductOffering';
import Cakes from './pages/Cakes'



const App = () => {
  return (

    <div className='wrapper'>
    <Router>
    <ScrollToTop />
      <Navbar />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/About" element={<About />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/Home" element={<Home />} />
          <Route path="/Collab" element={<Collab />} />
          <Route path="/Collab-CC-Amstel" element={<CollabCCAmstel />} />
          <Route path="/Product-Offering" element={<ProductOffering />} />
          <Route path="/Cakes" element={<Cakes />} />
        </Routes>
      </main>
      <Footer />
    </Router>
    </div>


   
  );
};

export default App;